import { render, staticRenderFns } from "./Timestamp.vue?vue&type=template&id=d59b1908&"
import script from "./Timestamp.vue?vue&type=script&lang=ts&"
export * from "./Timestamp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports